import React from "react";
import PropTypes from "prop-types";

import TagPill from "./pills/TagPill";
import getProductTypeValues from "../utilities/getProductTypeValues";

function getProductTypeName(type) {
    switch(type) {
        case "physical": return "Koop fysiek";
        case "digital": return "Koop digitaal";
        case "rental": return "Huur";
        case "course": return "Cursus";
        default: return "Onbekend";
    }
}

function getProductTypeColor(type) {
    switch(type) {
        case "physical": return "#1F6BDE";
        case "digital": return "#00B506";
        case "rental": return "#FF5000";
        case "course": return "#d9b00b";
        default: return "#595959";
    }
}

function ProductTypePill({ product, light = false }) {
    const types = getProductTypeValues(product);
    return (
        <React.Fragment>
            { types.map((type, index) => (
                light ? (
                    <TagPill key={ type } variant="light" className={ index > 0 ? "ml-1" : "" }>
                        { getProductTypeName(type) }
                    </TagPill>
                ) : (
                    <TagPill key={ type } color={ getProductTypeColor(type) } className={ index > 0 ? "ml-1" : "" }>
                        { getProductTypeName(type) }
                    </TagPill>
                )
            ))}
        </React.Fragment>
    )
}
ProductTypePill.propTypes = {
    product: PropTypes.object.isRequired,
    light: PropTypes.bool
}

export default React.memo(ProductTypePill);
